import { LanguageCode } from "../services/translation";

export interface LanguageConfig {
  countryCode: string;
  name: LanguageCode;
  label: string;
}

export const LANGUAGES: LanguageConfig[] = [
  {
    countryCode: 'US',
    name: 'en',
    label: 'English'
  },
  {
    countryCode: 'FR',
    name: 'fr',
    label: 'Français'
  },
  // {
  //   countryCode: 'MG',
  //   name: 'mg',
  //   label: 'Malagasy'
  // }
];

export const VALID_LANGUAGE_CODES = LANGUAGES.map(lang => lang.name);

export const getLanguageConfig = (code: LanguageCode): LanguageConfig | undefined => {
  return LANGUAGES.find(lang => lang.name === code);
};
